module.exports = __webpack_public_path__ + "bubble_conversation_2.e61423606d88b24264ac9881e33eb008.svg";